// extracted by mini-css-extract-plugin
module.exports = {"main":"AppMandatePopup_main__glMe7","content":"AppMandatePopup_content__r98_s","innerContent":"AppMandatePopup_innerContent__1lF1d","closeIcon":"AppMandatePopup_closeIcon__bMJv1"};